// extracted by mini-css-extract-plugin
export var contentContainer = "map-legend-item-module--contentContainer--G6G5V";
export var legendItemColor = "map-legend-item-module--legendItemColor--5EEx8";
export var legendItemText = "map-legend-item-module--legendItemText--Xf0k6";